import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsBasicLayout" */ './SportsBasicLayout'),
  modules: ['./SportsBasicLayout'],
  loading: () => null
});

export default LoadableWidget;
